import * as React from 'react';

const SvgInternet = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M28 4.667C15.166 4.667 4.666 15.167 4.666 28c0 12.833 10.5 23.333 23.334 23.333 12.833 0 23.333-10.5 23.333-23.333 0-12.833-10.5-23.333-23.333-23.333Zm0 4.666c1.4 0 2.8.234 4.2.467-.467.933-.934 1.633-1.867 2.333-.466.467-1.166.7-1.633 1.167-1.867.933-3.267 2.333-4.433 3.967-1.167 2.333-1.634 5.133-1.4 7.7 0 3.266 0 5.133-2.1 6.766C17.5 34.3 12.6 32.9 9.567 31.5c-.234-1.167-.234-2.333-.234-3.5 0-10.267 8.4-18.667 18.667-18.667ZM39.433 42.7c-.466-.933-.933-1.867-1.4-2.567-.233-.466-.467-.7-.7-1.166-.933-1.634-.466-2.334.934-4.667l.233-.467c.933-1.633 1.4-3.733 1.4-5.6 0-.7 0-1.633.233-2.333.467-1.633 3.967-2.1 6.3-2.333 1.633 7.233-1.166 14.7-7 19.133Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgInternet;
